import React from "react"
import { Icon as ChakraIcon, IconProps } from "@chakra-ui/react"

type Props = {
  size?: number
} & Omit<IconProps, "size">

const PaperclipIcon = ({ size = 4, ...props }: Props) => (
  <ChakraIcon
    viewBox="0 0 24 24"
    fontSize={`${size * 0.25}rem`}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551" />
  </ChakraIcon>
)

export default PaperclipIcon
